module.exports = __webpack_public_path__ + "static/media/Marina.d01a8fc9.svg";